import Vue from "vue";
import Router from "vue-router";
// import MainView from "../components/home.vue";
// import LoginView from "../components/login.vue"

Vue.use(Router);

export default new Router({
    mode:'hash',
    routes:[
        {
            path:"/",
            name:"main",
            component:()=>import("../components/home.vue"),
            meta:{
                page:"/",
                title:"驻外人员名单"
            }
        },
        {
            path:"/plt",
            name:'plt',
            component:()=>import("../components/plt.vue"),
            meta:{
                page:'/plt',
                title:"驻外人员时间表"
            }
        },
        {
            path:"/login",
            name:"login",
            component:()=>import("../components/login.vue"),
        }
    ]
});